import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\GetPaymentLinkCandidatesController::__invoke
* @see app/Http/Controllers/Invoice/GetPaymentLinkCandidatesController.php
* @route '/api/invoicing/{invoice}/payment-link-candidates'
*/
const GetPaymentLinkCandidatesController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPaymentLinkCandidatesController.url(args, options),
    method: 'get',
})

GetPaymentLinkCandidatesController.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/{invoice}/payment-link-candidates',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Invoice\GetPaymentLinkCandidatesController::__invoke
* @see app/Http/Controllers/Invoice/GetPaymentLinkCandidatesController.php
* @route '/api/invoicing/{invoice}/payment-link-candidates'
*/
GetPaymentLinkCandidatesController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return GetPaymentLinkCandidatesController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\GetPaymentLinkCandidatesController::__invoke
* @see app/Http/Controllers/Invoice/GetPaymentLinkCandidatesController.php
* @route '/api/invoicing/{invoice}/payment-link-candidates'
*/
GetPaymentLinkCandidatesController.get = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPaymentLinkCandidatesController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Invoice\GetPaymentLinkCandidatesController::__invoke
* @see app/Http/Controllers/Invoice/GetPaymentLinkCandidatesController.php
* @route '/api/invoicing/{invoice}/payment-link-candidates'
*/
GetPaymentLinkCandidatesController.head = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPaymentLinkCandidatesController.url(args, options),
    method: 'head',
})

export default GetPaymentLinkCandidatesController